import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import { routes } from '../../../../redux/api/routes';
import RequestCreditUploadImageDialog from '../../../dialogs/requestCreditUploadImageDialog';
import RequestReturnFileWarningDialog from '../../../dialogs/requestReturnFileWarningDialog';
import {
	createNewOrder,
	saveRequestCreditList,
	setRequestCreditDetails,
	updateRequestCreditParams,
	storeCreditUda
} from '../../../../redux/actions';

let { s3BucketAPIBaseURL } = routes;
class RequestCreditStep4 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			requestSubmitted: false,
			requestNumber:'',
			creditType: '',
			requestCreditDetails: null,
			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: '',
			UploadedItem:null,
			submitErrorMessage:false,
			isOOP:false,
			isOOPChecked: false,
			approverName:'',
			returnTypeIndicator:'',
			showOopErrorMessage: false,
			showRequestCreditUploadImageDialog: false,
			showRequestReturnFileWarningDialog:false,
			catalog: false
		};
	}

	componentWillMount() {
		const self = this;
		const { requestCreditDetails, requestCreditFilterListOfOrders } = self.props.order;
		if(!requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: '';
			self.setState({
				creditType,
				requestCreditDetails
			});
		}
	}

	componentDidMount() {
		const self = this;
		window.scrollTo(0, 0);
		const orderDetails = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		const { invoiceDate } = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		const relationShipTypes = self.props.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
		const invoice = self.props.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
		const defaultInvoice = self.props.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
		const invoiceAge = invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
		const { selectedAccount} = self.props.user;
		let customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE : "";
		const catalogGroups =["Countertop Microwave Ovens", "Window Room Air Conditioners", "Compact Refrigerators", "Drinking Water Filtration", 
			"Water Softeners", "Dehumidifiers"];
		if(orderDetails.items){
			for (const item of orderDetails.items) {
				if((item.selected) && this.state.creditType == "Scrap" && customerClassCode != "AS-IS" && moment(item.invoiceDate).isBefore(moment().subtract(invoiceAge, 'days'), 'day')) {
					self.setState({
						isOOP: true
					});
					break;
				}
				
			}
		}
		if(this.state.creditType == "Scrap"){
			let pim = self.props.order && self.props.order.requestCreditPimdata;
			let catalogArray =[];
			orderDetails && orderDetails.items.filter(item =>{return item.selected}).map(item =>{
				pim.map(pimItem =>{
					if(item.item == pimItem.item_number){
						catalogArray.push(catalogGroups.includes(pimItem.item_catalog_group));
						}})
			})
			if(!catalogArray.includes(false)){
				self.setState({
				 catalog : true
				 })}
		}
	}

	handleFileChange = (item, serial, index) =>  (event) => {
		const self = this;
		const files = event.target.files;
		const requestCreditDetails = self.state.requestCreditDetails;
		const allowedTypes = ['image/jpeg', 'image/pjpeg', 'image/gif', 'image/png', 'image/bmp', 'image/x-windows-bmp', 'application/pdf'];
		if (!requestCreditDetails.responseObject.items[index].fileUploadSerialErrors){
			requestCreditDetails.responseObject.items[index].fileUploadSerialErrors = new Map();
			self.props.setRequestCreditDetails(requestCreditDetails);
		}
		if(!requestCreditDetails.responseObject.items[index].serialAndUplodedFileList) {
			requestCreditDetails.responseObject.items[index].serialAndUplodedFileList = new Map();
		}
		requestCreditDetails.responseObject.items[index].serialAndUplodedFileList.get(serial) ? '': requestCreditDetails.responseObject.items[index].serialAndUplodedFileList.set(serial, []);
		self.props.setRequestCreditDetails(requestCreditDetails);
		if(files.length > 0) {
			const invalidFiles = Array.from(files).filter(file => !allowedTypes.includes(file.type));
            if (invalidFiles.length > 0) {
				requestCreditDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, 'Invalid file type.  Please select a JGP, PNG or PDF file.')
                self.props.setRequestCreditDetails(requestCreditDetails);
				this.setState({
					showRequestReturnFileWarningDialog :true
				})
                return;
            }
			for (let i = 0; i < files.length; i++) {
				if(files[i].size/1000 > 5000) {
					requestCreditDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, "Please select a file that is not larger than 5 MB")
					self.props.setRequestCreditDetails(requestCreditDetails);
					this.setState({
						showRequestReturnFileWarningDialog :true
					})
				} else {
					requestCreditDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, '')
					self.props.setRequestCreditDetails(requestCreditDetails);
				}
			}
			if(requestCreditDetails.responseObject.items[index].fileUploadSerialErrors.get(serial) === '') {
				this.uploadFiles(files, item, serial, index);
			}
		}
	};

	uploadFiles = async (files, item, serial, index) => {
		const self = this;
		const { userDetails } = self.props.user;
		const orderDetails = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		const requestCreditDetails = self.state.requestCreditDetails;
	
		// handle file upload
		const uploadFile = (file) => {
			const existingFileNames = requestCreditDetails.responseObject.items[index].serialAndUplodedFileList.get(serial);
	
			// Append the new file name to the array if it's not already there
			if (!existingFileNames.includes(file.name)) {
				existingFileNames.push(file.name);
			}
	
			const reader = new FileReader();
	
			reader.addEventListener('loadend', function (e) {
				fetch(s3BucketAPIBaseURL, {
					method: "POST",
					headers: {
						'Content-Type': 'application/json',
						"Authorization": `${userDetails.jwt}${userDetails.sso}`,
					},
					body: JSON.stringify({
						name:  `CustomerNet/ReturnAndCredit/Credits/${orderDetails.accountNumber}/${orderDetails.originalOrderNumber}/${orderDetails.originalOrderNumber}-${item.item}-${serial}-${moment()}`,
						type: file.type
					})
				}).then(function (response) {
					return response.json();
				}).then(function (json) {
					return fetch(json.uploadURL, {
						method: "PUT",
						body: new Blob([reader.result], {
							type: file.type
						})
					})
				}).then(function () {
					requestCreditDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, 'File is uploaded successfully.')
					requestCreditDetails.responseObject.items[index].serialAndUplodedFileList.set(serial, existingFileNames);
					self.props.setRequestCreditDetails(requestCreditDetails);
					self.setState({
						submitErrorMessage : false
					});
				});
			});
	
			reader.readAsArrayBuffer(file);
		};
	
		// Use Promise.all to wait for all uploads to complete
		await Promise.all(Array.from(files).map(uploadFile));
	}
	

	handleContinue(event) {
		event.preventDefault();
		const self = this;
		const adjPrdModList = self.props.user.allAdjPrcModList.responseObject;
		const orderDetails = self.state.requestCreditDetails && JSON.parse(JSON.stringify(self.state.requestCreditDetails.responseObject));
		orderDetails.deliveryPhone = orderDetails.deliveryPhone.replace("(", "").replace("-", "").replace(")", "").replace(" ", "");
		orderDetails.items = orderDetails.items.filter(item => item.selected === true);
		orderDetails.poNumber = orderDetails.poNumber.trim();
		orderDetails.items.forEach(item => {
			if (item.itemType === "A" && !item.serialNumber) {
				item.serialNumber = 'NA';
			}
			item.quantity = item.returnQuantity;
			item.returnReason = item.reasonCategoryLabel;
			item.returnReasonCode = item.reasonCategory;
			item.originalItemPrice = item.price;
			item.price = item.updatedPrice;
			item.item = item.bkpItem || item.item;
		});
		orderDetails["returnTypeIndicator"] = self.state.returnTypeIndicator;
		orderDetails["returnAuthPersonName"] = self.state.approverName;
		orderDetails["adjPrcMod"] = adjPrdModList[0].adjustmentName;
		let allfileUploaded = true;
		const serialcheckLIst = orderDetails.items.filter(itm => itm.serialNumber !== '' && itm.serialNumber !== 'NA' && itm.selected);
		for(const item of serialcheckLIst) {
			let count = item.returnQuantity;
			if(item.fileUploadSerialErrors ) {
				for (const [index, obj] of item.fileUploadSerialErrors.entries()) {
					const [serial, errorMessage] = obj;
					if(errorMessage !== "File is uploaded successfully.") {
						allfileUploaded = false;
						self.setState({
							submitErrorMessage : true,
							showRequestReturnFileWarningDialog : true
						});
						break;
					} else {
						count--;
						self.setState({
							submitErrorMessage : false
						});
					}
				} 
				if(count != 0){
					allfileUploaded = false;
						self.setState({
							submitErrorMessage : true,
							showRequestReturnFileWarningDialog : true
						});
				}
				//
			} else {
				allfileUploaded = false;
				self.setState({
					submitErrorMessage : true,
					showRequestReturnFileWarningDialog : true
				});
				break;
			}
			
		}
		if(self.state.creditType != "Scrap" ) {
			allfileUploaded = true;
			self.setState({
				submitErrorMessage : false
			});
		}
		
		if(((self.state.isOOP && self.state.isOOPChecked && self.state.approverName !== '' && self.state.approverName.length >= 5 && allfileUploaded ) 
		|| (!self.state.isOOP && !self.state.isOOPChecked && allfileUploaded ))){
			if (self.props.user.userDetails.isNonGEASsoUser && self.props.user.userDetails.isManRepSsoUser) {
				orderDetails.salesRepNum = self.props.getASMAndDSASMSSOList();
			}
			self.props.createNewOrder(orderDetails, `requestType=requestCredit`, false, response => {
				if(response.status) {
					if(self.state.isOOP) {
						let udaData = {
							...response.responseObject,
							returnAuthPersonName : self.state.approverName,
							returnTypeIndicator: self.state.returnTypeIndicator,
						};
						self.props.storeCreditUda (udaData, false, resp => {
							if(resp.status) {
								self.setState({
									requestSubmitted: true,
									requestNumber: response.responseObject.orderNumber,
									showOopErrorMessage: false,
								});
								self.props.setRequestCreditDetails(null);
								self.props.saveRequestCreditList(null);
								self.props.updateRequestCreditParams(null);
							}
						});
					} else {
						self.setState({
							requestSubmitted: true,
							requestNumber: response.responseObject.orderNumber,
							showOopErrorMessage: false,
						});
						self.props.setRequestCreditDetails(null);
						self.props.saveRequestCreditList(null);
						self.props.updateRequestCreditParams(null);
					}
					
				} else {
					browserHistory.push("/error");
				}
			});
		} else if(allfileUploaded && !self.state.catalog){
			self.setState({
				showOopErrorMessage: true,
				showRequestReturnFileWarningDialog:true
			})
		} else if(self.state.isOOP && allfileUploaded && self.state.catalog){
			self.props.createNewOrder(orderDetails, `requestType=requestCredit`, false, response => {
				if(response.status) {
					if(self.state.isOOP) {
						let udaData = {
							...response.responseObject,
							returnAuthPersonName : '',
							returnTypeIndicator: self.state.returnTypeIndicator,
						};
						self.props.storeCreditUda (udaData, false, resp => {
							if(resp.status) {
								self.setState({
									requestSubmitted: true,
									requestNumber: response.responseObject.orderNumber,
									showOopErrorMessage: false,
								});
								self.props.setRequestCreditDetails(null);
								self.props.saveRequestCreditList(null);
								self.props.updateRequestCreditParams(null);
							}
						});
					} else {
						self.setState({
							requestSubmitted: true,
							requestNumber: response.responseObject.orderNumber,
							showOopErrorMessage: false,
						});
						self.props.setRequestCreditDetails(null);
						self.props.saveRequestCreditList(null);
						self.props.updateRequestCreditParams(null);
					}

				} else {
					browserHistory.push("/error");
				}
			});
		}
	}

	calculateSum(items) {
		let totalSum = 0;
		items.forEach(item => {
			if(item.selected) {
				totalSum += parseFloat(item.creditAmount);
			}
		});
		return this.props.formatAmount2Decimal(totalSum);
	}

	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}
	handleCheckboxChange (event) {
		const self = this;
		const checked = event.target.checked;
		self.setState({
			isOOPChecked: checked
		});
	  }
	handleApproverName (event) {
		const self = this;
		const approverName = event.target.value;
			self.setState({
				approverName: approverName,
				returnTypeIndicator: 'OOP'
			});
	};

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    render() {
		const self = this;
		const { userDetails } = self.props.user;
		const orderDetails = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		const billingAddress = orderDetails && orderDetails.billingAddress;
		const isRestocking = orderDetails && orderDetails.items.filter(item => (item.item === 'RESTOCKING FEE' && self.state.creditType === 'Delivery/Services/Fees' && userDetails.typeOfUser == 'employee')).length > 0? true : false;
		const { selectedAccount} = self.props.user;
		let customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE : "";
        return (
			<div className='container'>
				<div className="d-none d-sm-block">
					{this.state.requestSubmitted && <p className="textRight">
						<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Confirmation of Credit Request</a>
					</p>}
					<div className="smallPush">
						{this.state.requestSubmitted
							?<h1 className="pageTitle">CONFIRMATION OF CREDIT REQUEST</h1>
							:<h1 className="pageTitle">REVIEW CREDIT REQUEST</h1>
						}
						{this.state.requestSubmitted
							?<div>
								{userDetails.typeOfUser === 'customer'
									?<p>The following request for credit has been submitted and will be reviewed for approval. Go to View Returns & Credits to view the status.</p>
									:<p>Thank you for Booking your credit. Go to View Returns & Credits to view the status. Booking may take up to an hour. The Credit Reference # below can be used to search for this return in View Returns & Credits.</p>
								}
							</div>
							:null
						}
						{this.state.requestSubmitted
							?<p><b>Credit Reference #:</b> {this.state.requestNumber}</p>
							:null
						}
						<p><b>Account #:</b> {orderDetails && orderDetails.accountNumber}</p>
					</div>
					<div className="smallPush">
						<p>
							<b>Bill To:</b>
							<br />
							{billingAddress && <span>
								{billingAddress.addressName && billingAddress.addressName.trim()}
								{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
								{billingAddress.address1  && billingAddress.address1.trim()}, {billingAddress.address2 && billingAddress.address2.trim()} <br/>
								{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()}, {billingAddress.zip && billingAddress.zip.trim()}<br />
								{billingAddress.phone}<br />
							</span>}
						</p>
					</div>
					<div className="smallPush" style={{display:"flex"}}>
						<div className="columns reviewCreditRequestColumns">
							<div className="column column1">
								<p>
									<b>Credit Request Entered By:</b> {this.props.user.userDetails.firstName} {this.props.user.userDetails.lastName}<br />
									<b>Credit Request Entered On:</b> {moment().format('MM/DD/YY')}<br />
									<b>Credit Type:</b> {this.state.creditType}
								</p>
							</div>
							<div className="column column2">
								<p>
									<b>Contact Phone:</b> {orderDetails && orderDetails.deliveryPhone}<br />
									<b>Credit Invoice Notes:</b> {orderDetails && orderDetails.creditInvoiceNotes}<br />
								</p>
							</div>
						</div>
						{self.state.isOOP && !self.state.catalog ? 
							<div className="column column3" style={{ border: '5px dotted black', padding: '10px', borderRadius:"10px", width:"33%" }}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<input
										type="checkbox"
										checked={this.state.isOOPChecked}
										onChange={this.handleCheckboxChange.bind(this)}
									/>
								{customerClassCode === "AS-IS" ? <p className="red" style={{ marginLeft: '1px' }}> This out of policy Scrap requires approval from the As-Is team. </p> 
									: <p className="red" style={{ marginLeft: '1px' }}> This out of policy Return requires Region Manager approval. </p>}
								</div>
								<p>By checking this box, I confirm that this has been approved and that I may be asked to provide an email from the approver upon audit.</p>
								<p className="bold">Please enter the name of approver here (Minimum 5 characters Required):</p>
								<input type="text" id="approverName" minLength ={5} placeholder='Approver Name' 
								onChange = { this.handleApproverName.bind(this)} 
								value={self.state.approverName}
								/>
							</div> : <div className="column column5"></div>}
					</div>
					<div className="push">
						<h2>Original CSO (Order number): {orderDetails && orderDetails.originalOrderNumber}</h2>
						<table className="invoicePrintView" style={{marginBottom: '-14px'}} cellPadding={0} cellSpacing={0} width="100%">
							<tbody>
								<tr>
									<th>Product #</th>
									<th>Credit<br/>Request<br/>Quantity</th>
									<th>Original<br/>Invoice #</th>
									<th style={{width:"10px"}}>Serial Number(s)</th>
									<th className="pictureUpload">Photo Upload <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "RequestCreditUploadImageDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
									<th>Reason for Credit Request</th>
									<th>Original<br/>Price<br/>(Each)</th>
									<th>Total<br/>Credit<br/>Amount</th>
								</tr>
								{orderDetails && orderDetails.items && orderDetails.items.map((item, orderIndex) => {
									if(item.selected)
										return [<tr key={orderIndex}>
											<td><b>{item.item}</b></td>
											<td>{item.returnQuantity}</td>
											<td>{item.invoiceNumber}</td>
											<td colSpan="2" className="serialNumber">
												<table>
													<tbody>
													{item.serialNumber.split(' ').map((serial, index) => (
														<tr key={index}>
														<td style={{width:"10px"}}>{serial}</td>
														{serial !== '' && serial !== 'NA' ? <td>
															<label className='blueButton' style={{width:"84%", textTransform:"none"}}>
															{`Choose Photo(s)`}
															<div style={{display:"none"}}>
															<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" 
															type="file" multiple placeholder='Upload Image' 
															onChange={this.handleFileChange(item, serial, orderIndex)} />
															</div>
															</label>
															{item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(serial) !== 'File is uploaded successfully.'?<p className="red"><b>{item.fileUploadSerialErrors.get(serial)}</b></p>:null}
															{item && item.fileUploadSerialErrors && item.fileUploadSerialErrors.get(serial) === 'File is uploaded successfully.'
															?<div>
															<p className="bold">{item.fileUploadSerialErrors.get(serial)}</p>
															{item.serialAndUplodedFileList && item.serialAndUplodedFileList.get(serial) ? (
															<div>
																{item.serialAndUplodedFileList.get(serial).map((fileName, i) => (
																<p style={{ fontSize: '12px' }} key={i}>{fileName}</p>
																))}
															</div>
															) : null}
														</div>
															:null}
														</td> : null}
														</tr>
													))}
													</tbody>
												</table>
											</td>
											<td>{item.reasonCategoryLabel}</td>
											<td className="text-right">{this.props.formatAmount2Decimal(item.price)}</td>
											<td className="text-right">{this.props.formatAmount2Decimal(item.creditAmount)}</td>
										</tr>]
									return null;
								})}
								<tr className="invoiceTotals">
									<td>Total</td>
									<td colSpan={ 6 }>&nbsp;</td>
									<td className="text-right">{orderDetails && this.calculateSum(orderDetails.items)}</td>
								</tr>
							</tbody>
						</table>
					</div>
					{this.state.requestSubmitted
						?null
						:<div>
							<div className="columns">
								<div className="column">
									<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
								</div>
								<div className="column textRight">
									<input type="submit" onClick={this.handleContinue.bind(this)} value="Submit Request" />
								</div>
							</div>
							<div style={{display:"flex",paddingTop:"1%"}}>
								<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep3', e)} className="bold">Return to previous screen</a>
								{self.state.submitErrorMessage ? <div className='red' style={{paddingLeft:"22%"}}>{`Scrap units require pictures to be uploaded before submittal. Please upload pictures before submitting.`}</div>:""}
								{this.state.showOopErrorMessage && !self.state.catalog ?
								<div className="push" style={{ textAlign: 'right' }}>
								<p className="bold red" style={{ marginTop: '1px', paddingLeft:"166px" }}>{`Out of policy scraps require RM approval. Please confirm approval above and enter the approver's name.`}</p>
							</div> : null}
							{ isRestocking ? <div className="push" style={{ textAlign: 'right' }}>
								<p className="bold red" style={{ marginTop: '1px',  paddingLeft:"476px" }}>{`All Restocking that is credited will be billed to the Region.`}</p>
							</div> : null}
							{this.state.showRequestCreditUploadImageDialog ?<RequestCreditUploadImageDialog handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
							</div>
						</div>
					}
				</div>
{/*Mobile view*/}
				<div className="d-block d-sm-none">
					

					<div className="smallPush">
						{this.state.requestSubmitted
							?<h1 className="pageTitle">CONFIRMATION OF CREDIT REQUEST</h1>
							:<h1 className="pageTitle">REVIEW CREDIT REQUEST</h1>
						}
					</div>

					<div>
						
						<div className='row'>
							{this.state.requestSubmitted
								?<div>
									{userDetails.typeOfUser === 'customer'
										?<p>The following request for credit has been submitted and will be reviewed for approval. Go to View Returns & Credits to view the status.</p>
										:<p>Thank you for Booking your credit. Go to View Returns & Credits to view the status. Booking may take up to an hour. The Credit Reference # below can be used to search for this return in View Returns & Credits.</p>
									}
								</div>
								:null
							}
						</div>

						<div className=''>
							{this.state.requestSubmitted
								?<p><b>Credit Reference #:</b> {this.state.requestNumber}</p>
								:null
							}
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
								Account #:
							</div>
							<div className='col-12'>
								{orderDetails && orderDetails.accountNumber}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
								Bill To:
							</div>
							{billingAddress && 
								<div className='col-12'>
							<p className="billingAddress">
									{billingAddress.addressName && billingAddress.addressName.trim()}
										{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
										{billingAddress.address1  && billingAddress.address1.trim()}, {billingAddress.address2 && billingAddress.address2.trim()} <br/>
										{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()}, {billingAddress.zip && billingAddress.zip.trim()}<br />
										{billingAddress.phone}
							</p>

							</div>}
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Request Entered By:
							</div>
							<div className='col-12'>
							{this.props.user.userDetails.firstName} {this.props.user.userDetails.lastName}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Request Entered On:
							</div>
							<div className='col-12'>
							{moment().format('MM/DD/YY')}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Type:
							</div>
							<div className='col-12'>
							{this.state.creditType}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Contact Phone:
							</div>
							<div className='col-12'>
							{orderDetails && orderDetails.deliveryPhone}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Invoice Notes:
							</div>
							<div className='col-12'>
							{orderDetails && orderDetails.creditInvoiceNotes}
							</div>
						</div>

					</div>

					{self.state.isOOP && !self.state.catalog &&
						<div className='container p-4 mt-2' style={{border:"solid red"}}>

							<div className='row mt-2' >
								<div className="form-check">
									<input 
										className="form-check-input checkbox-size" 
										type="checkbox" 
										checked={this.state.isOOPChecked}
										onChange={this.handleCheckboxChange.bind(this)}
										name="checkboxConfirm"
										id="checkboxConfirm"
									/>
									<label className="form-check-label bold checkbox-label-2" htmlFor="checkboxConfirm">
										This out of policy Return requires Region Manager approval.
									</label>
								</div>
							</div>

							<div className='row' >
							By checking this box, I confirm that this has been approved and that I may be asked to provide an email from the approver upon audit.
							</div>

							<div className='row mt-3 fw-bold' >
								Please enter the name of approver here (Minimum 5 characters Required):
							</div>

							<div className='row mt-2' >
								<input type="text" id="approverName" minLength ={5} placeholder='Approver Name' 
								className="fullWidth form-control inputHeight"
									onChange = { this.handleApproverName.bind(this)} 
									value={self.state.approverName}
									/>
							</div>
							
						</div>
					}

{this.state.requestSubmitted && <div className='row mt-3'>
							<div className='col-8'>
							<button className="bold uppercase" onClick={this.props.handlePrint} >Print Confirmation of Credit Request</button>
						</div>
					</div>}


					<div className='container headerColor captionContainerSingleLine'>
						<div className='row'>
							<div className='col-12 d-flex align-items-center'>
								<b>Original CSO (Order number): {orderDetails && orderDetails.originalOrderNumber}</b>
							</div>
						</div>
					</div>
					{orderDetails && orderDetails.items && orderDetails.items.map((item,index) => {
									if(item.selected)
										return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStep4${index}`}  key={index}>
														<div className="accordion-item">

															<h2 className="accordion-header" id={`headingRequestReturnCreditStep4${index}`}>
																<div className=''>
																	<div className='row accBtn'>
																		<div className='col-12'>
																			<button className="accBtn accordion-button  font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseRequestReturnCreditStep4${index}`} aria-expanded="true" aria-controls={`collapseRequestReturnCreditStep4${index}`}>
																				<span className='spaceBetweenText'>PRODUCT</span>  {item.item}
																			</button>
																		</div>
																	</div>
																</div>
															</h2>	

															<div id={`collapseRequestReturnCreditStep4${index}`}
																				className={`accordion-collapse collapse accBody show`} 
																				aria-labelledby={`headingRequestReturnCreditStep4${index}`}
																				show>

																<div className="">
																	
																<div className="row ">
																		<div className="col-8 fw-bold pt-4">Credit Request Quantity</div>
																		<div className="col-4 text-end pt-4">
																			{item.returnQuantity}
																		</div>
																		<hr className="hr hrSpec" />
																</div>

																
																
																	<div className="row ">
																		<div className="col-8 fw-bold">Original Invoice #</div>
																		<div className="col-4 text-end">{item.invoiceNumber}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	<div className="row ">
																		<div className="col-6 fw-bold">Reason for Credit Request</div>
																		<div className="col-6 text-end">{item.reasonCategoryLabel}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	

																	<div className="row ">
																		<div className="col-8 fw-bold">Original Price (Each)</div>
																		<div className="col-4 text-end">{this.props.formatAmount2Decimal(item.price)}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	

																	<div className="row ">
																		<div className="col-8 fw-bold">Total Credit Amount</div>
																		<div className="col-4 text-end">{this.props.formatAmount2Decimal(item.creditAmount)}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	

																	<div className="row mb-3">
																		<div className="col-12 fw-bold">Serial Number(s)</div>
																		<div className="col-12 mt-3">
																			
																				{item.serialNumber.split(' ').map((serial, sindex) => (
																					<div className='container' key={sindex}>
																						<div className='row' >
																							<div className='col-4'>
																								{serial}
																							</div>
																							{serial !== '' && serial !== 'NA' && <div className='col-8'>
																								<span className='float-end'>
																								<label style={{textDecoration:"underline", color:"#0d6efd"}}>
																									{`Choose Photo(s)`}
																									<div style={{display:"none"}}>
																										<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" 
																										type="file" multiple placeholder='Upload Image' 
																										onChange={this.handleFileChange(item, serial, index)} />
																									</div>
																								</label>
																								<a className="questionMarkIcon ms-2" href="" onClick={this.handleDialog.bind(this, "RequestCreditUploadImageDialog", true)}>
																									<img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" />
																								</a>
																								</span>

																							</div>}
																						</div>
																						
																						{item && item.fileUploadSerialErrors && item.fileUploadSerialErrors.get(serial) === 'File is uploaded successfully.' &&
																							<div className='row'>
																								<div className='col-6'>
																									<p className="successWord">{item.fileUploadSerialErrors.get(serial)}</p>
																								</div>
																								{item.serialAndUplodedFileList && item.serialAndUplodedFileList.get(serial) &&<div className='col-6 overFlowWrap'>
																											{item.serialAndUplodedFileList.get(serial).map((fileName, i) => (
																												<p className='text-end' style={{ fontSize: '11px'}} key={i}>{fileName}</p>
																											))}
																								</div>	}
																							</div>
																						}

																						{((item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(serial) !== 'File is uploaded successfully.' ) && this.state.showRequestReturnFileWarningDialog)
																						?<RequestReturnFileWarningDialog content ={item.fileUploadSerialErrors.get(serial)} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
																						:null}
																						
																					</div>
																				))}
																			
																		</div>
																		<hr className="hr hrSpec" />	
																	</div>
																			
																

																	
																</div>
															</div>
														</div>
													</div>
										return null;
							})}

{orderDetails && orderDetails.items &&<div className='totalContainer'>				
																			<div className='container totalStyle'>
																				<div className='row '>
																					<div className="col-8 fw-bold">Total</div>
																					<div className="col-4 text-end">{orderDetails && this.calculateSum(orderDetails.items)}</div>
																				</div>
																			</div>
																		</div>}
{this.state.requestSubmitted
						?null :
						<div>
						<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							<span>
								<button id="continueButton" className='submitBtnSize' onClick={this.handleContinue.bind(this)}>Submit Request</button>
							</span>
						</div>
					

					<div className="container mt-4 backLink">
					<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
					</div>
					</div>
	}
					

					<div className="container mt-4 backLink">
					{
						self.state.submitErrorMessage && self.state.showRequestReturnFileWarningDialog && 
						<RequestReturnFileWarningDialog content ={`Scrap units require pictures to be uploaded before submittal. Please upload pictures before submitting.`} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
					}

					{
						self.state.showOopErrorMessage && self.state.showRequestReturnFileWarningDialog && !self.state.catalog &&
						<RequestReturnFileWarningDialog content ={`Out of policy scraps require RM approval. Please confirm approval above and enter the approver's name.`} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
					}

					{
						 isRestocking ? <div className="push">
								<p className="bold red" >{`All Restocking that is credited will be billed to the Region.`}</p>
							</div> : null
					}
					
							{this.state.showRequestCreditUploadImageDialog ?<RequestCreditUploadImageDialog handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
									</div>

									<div style={{height:"200px"}}></div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	saveRequestCreditList: (requestCreditList) => dispatch(saveRequestCreditList(requestCreditList)),
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
	updateRequestCreditParams: (data) => dispatch(updateRequestCreditParams(data)),
	storeCreditUda: (payload, showLoader, callback) => dispatch(storeCreditUda(payload, showLoader, callback))
});

RequestCreditStep4 = connect(mapStateToProps, mapDispatchToProps)(RequestCreditStep4);
export default RequestCreditStep4;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditStep4.js